export enum Networks {
  // CRONOS = 25,
  ARBITRUM = 42161,
  ETHW = 10001,
}

export const DEFAULD_NETWORK = Networks.ETHW;
